import { render, staticRenderFns } from "./add_index.vue?vue&type=template&id=192c4bd0&scoped=true"
import script from "./add_index.vue?vue&type=script&lang=js"
export * from "./add_index.vue?vue&type=script&lang=js"
import style0 from "./add_index.vue?vue&type=style&index=0&id=192c4bd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192c4bd0",
  null
  
)

export default component.exports